import moment from 'moment';
import renderAddress from '../../../utils/renderAddress';

/**
   * construct a script tag for each class (for better search results on google)
   * @param {Object} classObject
   * @return {String}
   */
const renderWorkoutStructuredData = (workout) => {
  const startTime = new Date(workout.from);
  const weekDay = startTime.getDay();
  const enDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const weekName = enDayNames[weekDay];

  return `
      <script type="application/ld+json">
        {
          "@context": "http://schema.org/",
          "@type": "Service",
          "name": "${workout.name}",
          "areaServed": {
            "@type": "Place",
            "name": "${workout.partner.name}",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "${workout.location.city}",
              "streetAddress": "${renderAddress(workout.location, false)}"
            }
          },
          "hoursAvailable": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": "${weekName}",
            "opens": "${moment(workout.from).format('HH:mm')}",
            "closes": "${moment(workout.till).format('HH:mm')}"
          }
        }
      </script>
    `;
};

export default renderWorkoutStructuredData;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/inventoryOverview/utils/renderWorkoutStructuredData.js